import { Colors, Animation, Zindexes, Typography } from "@zapier/design-system";
import { css, keyframes } from "@emotion/react";
import { getResponsiveStyles } from "@/utils/getResponsiveStyles";

const openAnimation = keyframes({
  "0%": {
    transform: "translateY(-10px)",
    opacity: 0,
  },
  "30%": {
    transform: "translateY(-10px)",
    opacity: 0,
  },
  "100%": {
    transform: "translateY(0)",
    opacity: 1,
  },
});

export const Styles = {
  root: css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",

    "*": {
      boxSizing: "border-box",
      color: `${Colors.neutral800}`,
      ...Typography.paragraph3,
      fontWeight: 500,

      a: {
        outline: "none",
        color: "inherit",

        "&:focus-visible, &:hover": {
          color: `${Colors.blue}`,
        },

        "&:focus-visible": {
          outline: `1px solid ${Colors.blue}`,
        },
      },
    },
  }),

  content: css(
    getResponsiveStyles({
      mobile: {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minWidth: 0,
        maxWidth: "none",
        zIndex: Zindexes.modalOverlay,
        gap: "10px",
        borderRadius: "5px",
        border: `1px solid ${Colors.black}`,
        background: `${Colors.neutral100}`,
        boxShadow: `5px 5px 0px 0px ${Colors.earth}`,
        top: "calc(100% + 24px)",
        right: 0,
        padding: "35px 27px 31px 20px",
        animation: `${Animation.transitionDuration} ease-out ${openAnimation}`,
      },
      tablet: css({
        padding: "32px 54px 32px 36px",
        width: "calc(100vw - 40px)",
      }),
      desktop: css({
        width: "715px",
      }),
    })
  ),

  triggerButton: css(
    getResponsiveStyles({
      mobile: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        backgroundColor: "transparent",
        padding: 0,
        border: "none",
        color: Colors.neutral800,
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "125%",
        textDecorationLine: "underline",
        outline: "none",

        "&:focus, &:hover": {
          color: Colors.blue,
        },
      },
      tablet: css({
        marginLeft: "auto",
      }),
    })
  ),

  closeButton: css({
    position: "absolute",
    top: "15px",
    right: "15px",
    backgroundColor: "transparent",
    border: "1px solid transparent",
    borderRadius: "3px",
    color: Colors.neutral800,
    padding: 0,
    outline: "none",

    "&:focus, &:hover": {
      color: Colors.blue,
    },

    "&:focus-visible": {
      border: `1px solid ${Colors.blue}`,
    },
  }),

  textContainer: css(
    getResponsiveStyles({
      mobile: {
        display: "grid",
        gap: "23px",
      },
      tablet: css({
        gap: "13px",
      }),
    })
  ),

  title: css(
    getResponsiveStyles({
      mobile: {
        ...Typography.pageHeader9,
        fontWeight: 600,
      },
      tablet: css({
        ...Typography.pageHeader7,
        fontSize: "40px",
      }),
    })
  ),
};
